import {
  provideTaiga,
  tuiButtonOptionsProvider,
  tuiIconResolverProvider,
  tuiTextfieldOptionsProvider,
} from '@taiga-ui/core';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, signal } from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withComponentInputBinding,
  withViewTransitions,
} from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { provideNgxStripe } from 'ngx-stripe';

import { routes } from './app.routes';
import { authInterceptor } from '@core/interceptors/auth-interceptor';
import { AppTitleStrategy } from '@core/router/app-title.strategy';
import { provideAuth } from '@core/providers/auth.provider';
import { provideAnalytics } from '@core/providers/analytics.provider';
import { environment } from '@environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    // Registered before provideAuth() so mixpanel.init() has completed by the
    // time the auth initializer resolves a session and calls identify().
    provideAnalytics(),
    provideAuth(),
    provideNgxStripe(environment.stripeKey),
    provideTaiga(),
    tuiIconResolverProvider((name: string) => {
      if (name.startsWith('@img.')) {
        return `custom-icons/${name.replace('@img.', '')}.svg`;
      }

      const taigaName = name.replace(/^@tui\./, '');
      return `assets/taiga-ui/icons/${taigaName.replaceAll('.', '/')}.svg`;
    }),
    tuiTextfieldOptionsProvider({ size: signal('m'), appearance: signal('outline') }),
    tuiButtonOptionsProvider({ size: 's' }),
  ],
};
